import React from "react";
import "./HierarchyLines.css";

const HierarchyLines = ({
  idx,
  totalLength,
  depth = 0,
  noChild = true,
  initialTop = 54,
  zIndex = 1,
  needPositiveTranslate = false,
  positiveTranslate = 0,
  hidden = false,
}) => {
  const yOffset = idx == 0 ? 0 : 7;
  const totalLines = idx == -1 ? 5 : 5;
  const additionalOffset = depth * 0.88;
  const containerTransform = !needPositiveTranslate
    ? `translate(-50%, -${initialTop}%)`
    : `translate(-50%, ${positiveTranslate}%)`;
  const extraChildLeft = 5;
if (hidden) return null;
  return (
    <React.Fragment>
      <div
        className="line-test-container"
        style={{
          transform: containerTransform,
          left: `${1.1 + additionalOffset}rem`,
          zIndex: zIndex,
        }}
      >
        <div className="line-test-body">
          {Array.from({ length: totalLines }).map((_, i) => (
            <div
              key={i}
              className="line-child"
              style={i === 0 ? { marginTop: `${i + 1}px` } : {}}
            ></div>
          ))}
          {noChild && (
            <div
              className="line-extra-child"
              style={{ left: `${extraChildLeft}px` }}
            ></div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default HierarchyLines;
